import { REGISTER_PM_TRACKING_REQUEST } from '.';

export function registerPmTrackingRequest(event: string) {
  return { event, type: REGISTER_PM_TRACKING_REQUEST };
}
